import React from 'react';

import FolderLayout from 'Components/HumanResources/StaffFolder/FolderLayout';
import {Card, SimpleTable, formatDate} from 'Components/HumanResources/StaffFolder/Ui';
import StaffFormsChecklist from 'Components/HumanResources/StaffFormsChecklist';
import ViewCmsElementRecords from 'Components/Utilities/ViewCmsElementRecords';
import CreateCmsElementRecordModal from 'Components/Partials/Modals/CreateCmsElementRecordModal';
import {Pagination} from 'Components/Partials';

import {Modal} from 'Services';
import UsersApi from 'Services/Api/Admin/HumanResources/Users';

/**
 * Staff folder: Forms. The staff forms checklist, every other form the person has filled in,
 * and the full table of staff form records.
 */
export default class Forms extends React.Component {
    /**
     * @var state
     */
    state = {
        otherForms: null,
        formTypes: [],
        meta: null,
        page: 1,
        formFilter: '',
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.loadOtherForms();
    };

    /**
     * @method loadOtherForms
     */
    loadOtherForms = async () => {
        const {page, formFilter} = this.state;

        this.setState({otherForms: null});

        const response = await UsersApi.getFolderOtherForms(this.props.match.params.user, {
            page,
            cms_element_id: formFilter || null,
        });

        this.setState({
            otherForms: response.success ? response.data.data : [],
            formTypes: response.success ? response.data.form_types : [],
            formFilter: response.success ? (response.data.cms_element_id ?? '') : formFilter,
            meta: response.success ? response.data.meta : null,
        });
    };

    /**
     * @method view
     * @param {object} record
     */
    view = (record) => {
        Modal.open({
            component: CreateCmsElementRecordModal,
            props: {
                showElementsDropdown: false,
                element_id: record.element_id,
                element_record_id: record.id,
            },
        });
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const userId = this.props.match.params.user;
        const {otherForms, formTypes, meta, page, formFilter} = this.state;

        return (
            <FolderLayout userId={userId}>
                {({user}) => (
                    <div className="space-y-5">
                        <StaffFormsChecklist userId={userId} key={userId} />

                        <Card
                            title={`Other forms ${user.first_name} has filled in`}
                            id="f-other"
                            subtitle={`Everything submitted under this login, newest first${meta ? ` (${meta.total})` : ''}`}
                            action={
                                <div className="flex flex-col gap-1">
                                    <label htmlFor="f-type" className="text-sm font-bold text-gray-600">Form type</label>
                                    <select
                                        id="f-type"
                                        className="rounded-xl border-2 border-gray-300 py-2 px-3 bg-white min-w-[14rem]"
                                        value={formFilter}
                                        onChange={(event) => this.setState({formFilter: event.target.value, page: 1}, this.loadOtherForms)}
                                    >
                                        {formTypes.map(type => <option key={type.id} value={type.id}>{type.label}</option>)}
                                    </select>
                                </div>
                            }
                        >
                            <SimpleTable
                                headings={['Form', 'About', 'Date', '']}
                                perPage={0}
                                empty={otherForms ? 'No other forms filled in.' : 'Loading...'}
                                rows={(otherForms ?? []).map(record => [
                                    <span className="font-bold">{record.form}</span>,
                                    record.about ?? '',
                                    formatDate(record.created_at),
                                    <button type="button" className="font-bold text-app-leading hover:underline" onClick={() => this.view(record)}>
                                        View form
                                    </button>,
                                ])}
                            />

                            {meta && meta.total > 0 && (
                                <div className="mt-4 flex flex-wrap items-center justify-between gap-4">
                                    <span className="text-sm text-gray-600">Showing {meta.from} to {meta.to} of {meta.total}</span>
                                    {meta.last_page > 1 && (
                                        <Pagination
                                            page={page}
                                            pageCount={meta.last_page}
                                            goToPage={(next) => this.setState({page: next}, this.loadOtherForms)}
                                        />
                                    )}
                                </div>
                            )}
                        </Card>

                        <Card title="All staff form records" id="f-records">
                            <ViewCmsElementRecords staff_form={true} user_id={userId} push_to_history={false} />
                        </Card>
                    </div>
                )}
            </FolderLayout>
        );
    }
}
